export default __webpack_public_path__ + "static/media/phone.92f3e13e.svg";